<template>
  <div class="v8-card">
    <!-- Header -->
    <div class="v8-header">
      <div class="v8-header-top">
        <h3 class="v8-title">{{statSubtitle}}</h3>
        <select v-if="filter" :name="action" @change="ChangeDatetop($event)" v-model="timeserchtype" class="v8-select">
          <option value="today">Today</option>
          <option value="thismonth">This Month</option>
          <option value="lastmonth">Last Month</option>
          <option value="thisyear">This Year</option>
          <option value="betweendate">Between date</option>
        </select>
      </div>

      <!-- Filters -->
      <div v-if="filter" class="v8-filters">
        <div class="v8-filter-row">
          <div class="v8-filter-item" v-if="filterseller && currentUser && currentUser.type && currentUser.role && currentUser.role.name && currentUser.role.name!='Seller' && currentUser.type!='Seller'">
            <v-select @search="getUsersDebance($event,'shipsen')" @input="CheckSellerProducts($event,action,'seller')" label="fullName" placeholder="Seller" :options="sellers" v-model="sellerdata" class="v8-filter-select"></v-select>
          </div>
          <div class="v8-filter-item" v-if="dataChart && dataChart.status">
            <v-select @input="CheckSellerProducts($event,action,'sort')" label="name" placeholder="Sort by" :options="dataChart.status" v-model="sortby" class="v8-filter-select"></v-select>
          </div>
          <button class="v8-filter-clear" @click="removedata(action)">
            <i class="material-icons" style="font-size:16px">close</i>
          </button>
        </div>
        <div v-if="timeserchtype=='betweendate'" class="v8-filter-date">
          <date-picker placeholder="Range date ..." format="YYYY-MM-DD" type="date" class="v8-datepicker" v-model="fromDate" range></date-picker>
          <button @click="FindRecordsBetweenDate()" :class="!fromDate?'noselect':''" :disabled="!fromDate" class="v8-filter-search">
            <i class="material-icons" style="font-size:18px">search</i>
          </button>
        </div>
      </div>
    </div>

    <!-- Ranked list -->
    <div class="v8-body">
      <loading :active.sync="loading" :is-full-page="fullPage"></loading>
      <div v-if="rankedSellers.length > 0" class="v8-ranked-list">
        <div v-for="(item, index) in visibleSellers" :key="index" class="v8-rank-item">
          <div class="v8-rank-badge" :class="'v8-rank-' + (index < 3 ? index + 1 : 'default')">{{ index + 1 }}</div>
          <div class="v8-rank-info">
            <span class="v8-rank-name">{{ item.name }}</span>
            <div class="v8-rank-bar-wrap">
              <div class="v8-rank-bar" :style="'width:' + item.percent + '%; background:' + item.barColor"></div>
            </div>
          </div>
          <div class="v8-rank-stats">
            <div v-for="(stat, si) in item.stats" :key="si" class="v8-rank-stat">
              <span class="v8-rank-stat-val" :style="'color:' + stat.color">{{ stat.value }}</span>
              <span class="v8-rank-stat-label">{{ stat.label }}</span>
            </div>
          </div>
        </div>
        <button v-if="rankedSellers.length > 9" @click="showAll = !showAll" class="v8-show-more">
          <i class="material-icons" style="font-size:16px;margin-right:4px">{{ showAll ? 'expand_less' : 'expand_more' }}</i>
          {{ showAll ? 'Show less' : 'Show more (' + (rankedSellers.length - 9) + ')' }}
        </button>
      </div>
      <div v-else class="v8-empty">No data available</div>
    </div>

    <!-- Hidden chart for compatibility -->
    <div style="display:none"><highcharts :options="chartOptions"></highcharts></div>
  </div>
</template>
<script>
export default {
  name: "card-stats-v8",
  props: {
   loading:{required:false},
   statSubtitle: {default: "Traffic",},
   filter: {default: false,},
   sellers:{type:Array},
   id:{type:String},
   from:{},
   to:{},
   dataChart:{type:Object},
   label:{type:String},
   timeserch:{},
   currency: {default:"xof"},
   action: {},
   seller:{},
   currentUser:{type:Object},
   sortby_toptraits:{default: "All"},
   filterseller: {
      default: false,
    },
  },
  computed: {
    rankedSellers() {
      if (!this.dataChart || !this.dataChart.sellers || !this.dataChart.series) return [];
      const sellers = this.dataChart.sellers;
      const series = this.dataChart.series;
      const colors = ['#4285f4', '#36b37e', '#ffab00', '#ff5630', '#6554c0', '#00b8d9'];
      const statusColors = { 'confirmed': '#22c55e', 'cancelled': '#ef4444', 'pending': '#f59e0b', 'traits': '#8b5cf6', 'unreached': '#64748b' };

      let items = sellers.map((name, i) => {
        let total = 0;
        let stats = [];
        series.forEach(s => {
          const val = s.data && s.data[i] !== undefined ? s.data[i] : 0;
          total += val;
          if (val > 0) {
            stats.push({ label: s.name, value: val, color: (s.name && statusColors[s.name.toLowerCase()]) || '#64748b' });
          }
        });
        return { name, total, stats };
      });

      items.sort((a, b) => b.total - a.total);
      const max = items.length > 0 ? items[0].total : 1;

      return items.map((item, i) => ({
        ...item,
        percent: max > 0 ? Math.round((item.total / max) * 100) : 0,
        barColor: colors[i % colors.length],
      }));
    },
    visibleSellers() {
      return this.showAll ? this.rankedSellers : this.rankedSellers.slice(0, 9);
    },
  },
  data() {
    return {
      fullPage: false,
      showAll: false,
      myChart: "",
      timeserchtype:this.timeserch,
      fromDate:this.from,
      toDate:this.to,
      sellerdata:this.seller,
      sortby:this.sortby_toptraits,
      // chartOptions: { 
      //               chart: {
      //                   type: 'bar',
      //                   renderTo: 'container',
      //                    height: 400,
      //                   styledMode: true
      //               },
      //               credits: {
      //                   enabled: false
      //               },
      //               title: {
      //                   text: null,
      //               },
      //               subtitle: {
      //                   text: null
      //               },
      //               xAxis: {
      //                   type: 'category',
      //                   // categories: ['Africa', 'America', 'Asia', 'Europe', 'Oceania'],
      //                   title: {
      //                       text: 'Product name',
      //                   },
      //                    labels: {
      //                       overflow: 'justify'
      //                   }
      //               },
      //               yAxis: {
      //                   min: 0,
      //                   title: {
      //                       text: 'Quantity order paid',
      //                       align: 'high'
      //                   },
      //                   labels: {
      //                       overflow: 'justify'
      //                   }
      //               },
      //               tooltip: {
      //                   valueSuffix: ' quantity'
      //               },
      //               plotOptions: {
      //                   series: {
      //                       stacking: 'normal'
      //                       },
      //                   bar: {
      //                       dataLabels: {
      //                           enabled: true,
      //                           color: 'white',
      //                           align: "right",
      //                           format: '{y} Quantity paid',
      //                           inside: false,
      //                           style: {
      //                               fontWeight: 'bold'
      //                           },
      //                           verticalAlign: "middle"
      //                       }
      //                   }
      //               },
      //               legend: {
      //                    enabled: false
      //               },
      //               series: []
                    
      //               // series: [
      //               // {
      //               //     type: 'bar',
      //               //     name: ['ou', 'kl', '635', '203', '2'],
      //               //     data: [107, 31, 635, 203, 2]
      //               // }]
      //   }
      chartOptions :{
          series: [],
          chart: {
            type: 'bar',
            height: 600,
            //stacked: true,
            renderTo: 'container',
            styledMode: true
          },
          colors: ['#b84644', '#4576b5','#b84644', '#4576b5','#b84644'],
        plotOptions: {
                series: {
                  stacking: 'normal'
                  },
              bar: {
                distributed: true,
                dataLabels: {
                  
                    enabled: true,
                    color: 'white',
                      align: "right",
                      format: '{y}',
                      inside: false,
                      style: {fontWeight: 'bold'},
                    verticalAlign: "middle"
                }
        }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          text: null
        },
        
        xAxis: {
            type: 'category',
            categories: [],
            title: {
                text: 'Sellers',
            },
              labels: {
                overflow: 'justify',
            }
        },
        yaxis: {
          title: {
            text: undefined
          },
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + "K"
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'center',
          offsetX: 40
        }
        }
    };
  },
 watch: {
   'timeserch': function () {
      this.timeserchtype=this.timeserch;
   },
   'seller': function () {
       console.log('seller------',this.seller)
       this.sellerdata=this.seller;
   },
    dataChart: function () {
      this.drawChart(this.dataChart);
    },
  },
  async mounted(){
    await this.drawChart(this.dataChart);
    if(this.currentUser && this.currentUser.role && this.currentUser.role.name=='Seller' && this.currentUser.type=='Seller') {
      this.sellerdata=this.currentUser;
      //this.chartOptions.chart.height=720;
    }
  },
   methods: {
     ChangeDatetop: function (val) {
         this.$emit("ChangeDatetop", val);
    },
    getUsersDebance: function (name) {
        this.$emit("getUsersDebance", name);
     }, 
    FindRecordsBetweenDate: function (val) {
         this.$emit("FindRecordsBetweenDate", this.action,this.fromDate,this.toDate);
    },
    removedata: function (val) {
        this.$emit("removedata", this.action);
     }, 
    async CheckSellerProducts(seller,action,model){
       this.$emit("CheckSellerProducts", seller,action,model);
    },
    generateData(baseval, count, yrange) {
    var i = 0;
    var series = [];
    while (i < count) {
      var x = baseval;
      var y = Math.floor(Math.random() * (yrange.max - yrange.min + 1)) + yrange.min;
      var z = Math.floor(Math.random() * (75 - 15 + 1)) + 15;
  
      series.push([x, y, z]);
      baseval += 86400000;
      i++;
    }
    return series;
  },
    drawChart(chartData,label=null) {
      this.chartOptions.series=chartData.series;
      this.chartOptions.xAxis.categories=chartData.sellers;
     // this.chartOptions.colors=chartData.colors;
    },
   }
};
</script>
<style scoped>
.v8-card {
  border-radius: 16px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.06);
  border: 1px solid #e5e7eb;
  background: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  position: relative;
  transition: all 0.3s ease;
}
.v8-card:hover {
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  transform: translateY(-2px);
}
.v8-header {
  padding: 20px 24px 12px;
  border-bottom: 1px solid #f1f5f9;
}
.v8-header-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.v8-title { font-size: 18px; font-weight: 700; color: #1e293b; margin: 0; }
.v8-select {
  appearance: auto; font-size: 13px; font-weight: 500; color: #475569;
  background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 10px;
  padding: 8px 14px; cursor: pointer; outline: none;
}
.v8-filters { background: #f8fafc; border-radius: 10px; padding: 10px; margin-bottom: 4px; }
.v8-filter-row { display: flex; align-items: center; gap: 6px; }
.v8-filter-item { flex: 1; min-width: 0; }
.v8-filter-select { font-size: 12px !important; background: #ffffff; border-radius: 8px; }
.v8-filter-clear {
  width: 30px; height: 30px; min-width: 30px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 8px; border: none; background: #fee2e2; color: #ef4444;
  cursor: pointer; transition: all 0.2s;
}
.v8-filter-clear:hover { background: #fecaca; }
.v8-filter-date { display: flex; align-items: center; gap: 6px; margin-top: 8px; }
.v8-datepicker { flex: 1; }
.v8-filter-search {
  width: 34px; height: 34px; min-width: 34px;
  display: flex; align-items: center; justify-content: center;
  border-radius: 8px; border: none; background: #4285f4; color: #fff; cursor: pointer;
}
.v8-filter-search.noselect { opacity: 0.5; cursor: not-allowed; }

/* Body */
.v8-body { padding: 8px 16px 16px; position: relative; }
.v8-ranked-list { padding: 4px 0; }
.v8-rank-item {
  display: flex; align-items: center; padding: 10px 8px;
  border-bottom: 1px solid #f1f5f9; transition: background 0.15s;
}
.v8-rank-item:last-child { border-bottom: none; }
.v8-rank-item:hover { background: #f8fafc; border-radius: 8px; }
.v8-rank-badge {
  width: 28px; height: 28px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: 700; flex-shrink: 0; margin-right: 12px;
}
.v8-rank-1 { background: #fef3c7; color: #b45309; }
.v8-rank-2 { background: #e5e7eb; color: #4b5563; }
.v8-rank-3 { background: #fed7aa; color: #c2410c; }
.v8-rank-default { background: #f1f5f9; color: #64748b; }
.v8-rank-info { flex: 1; min-width: 0; margin-right: 12px; }
.v8-rank-name {
  font-size: 13px; font-weight: 600; color: #1e293b;
  display: block; margin-bottom: 5px;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.v8-rank-bar-wrap { width: 100%; height: 5px; background: #f1f5f9; border-radius: 3px; overflow: hidden; }
.v8-rank-bar { height: 100%; border-radius: 3px; transition: width 0.5s ease; }
.v8-rank-stats { display: flex; gap: 8px; flex-shrink: 0; }
.v8-rank-stat { text-align: center; }
.v8-rank-stat-val { font-size: 14px; font-weight: 700; display: block; line-height: 1; }
.v8-rank-stat-label { font-size: 9px; color: #94a3b8; text-transform: uppercase; }
.v8-show-more {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 10px;
  margin-top: 8px;
  border: 1px dashed #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #4285f4;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}
.v8-show-more:hover {
  background: #eff6ff;
  border-color: #4285f4;
}
.v8-empty { padding: 40px 0; text-align: center; color: #94a3b8; font-size: 14px; }
</style>
